<script setup lang="ts">
import DAlert from '../../design/components/DAlert.vue';
import { useNotice } from '../../app/composables/useNotice.ts';

const { notices, dismiss } = useNotice();
</script>

<template>
  <div class="notice-host" aria-live="polite">
    <template v-for="n in notices" :key="n.id">
      <div v-if="n.link" class="cell">
        <DAlert :tone="n.tone"
          >{{ n.text }}
          <RouterLink :to="{ name: n.link.routeName }" @click="dismiss(n.id)">{{
            n.link.label
          }}</RouterLink></DAlert
        >
      </div>
      <button v-else type="button" class="cell" @click="dismiss(n.id)">
        <DAlert :tone="n.tone">{{ n.text }}</DAlert>
      </button>
    </template>
  </div>
</template>
